// data/items/misc.js
// Miscellaneous items (currency, byproducts)

export const MISC = [
    {
        id: 'coins', name: 'Coins', icon: '🪙', color: '#ffd700', type: 'currency', value: 0,
        sprite: { sheet: 'assets/icons/ui_icons/coin_1.png', x: 0, y: 0, width: 64, height: 64 },
        sprites: [
            { minQty: 1, sheet: 'assets/icons/ui_icons/coin_1.png', x: 0, y: 0, width: 64, height: 64 },
            { minQty: 100, sheet: 'assets/icons/ui_icons/coin_2.png', x: 0, y: 0, width: 64, height: 64 },
            { minQty: 1000, sheet: 'assets/icons/ui_icons/coin_3.png', x: 0, y: 0, width: 64, height: 64 },
            { minQty: 10000, sheet: 'assets/icons/ui_icons/coin_4.png', x: 0, y: 0, width: 64, height: 64 },
        ]
    },
    { id: 'ashes', name: 'Ashes', color: '#808080', value: 1 },
    { id: 'spun_fiber', name: 'Spun Fiber', color: '#f5f5dc', value: 10 },
    { id: 'feathers', name: 'Feathers', color: '#d4c5a9', value: 1 },
    {
        id: 'universal_glyph_catalyst',
        name: 'Universal Glyph Catalyst',
        icon: '✨',
        color: '#ff69b4',
        description: '2x glyph output. Any ichor works for any tier recipe.',
        value: 50000
    },
    {
        id: 'veil_ember',
        name: 'Veil Ember',
        icon: '🔥',
        color: '#ff6b35',
        description: 'A flickering ember from beyond the Pyre Veil. Used in ancient crafting.',
        value: 250
    },
    {
        id: 'universal_set_token',
        name: 'Universal Set Token',
        icon: '🎫',
        color: '#e6c619',
        description: 'A rare token from the Ashen Crucible. Trade at the Awakening Store for any dormant set armor piece.',
        value: 5000
    }
];

export default MISC;
